import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/tiffin-seva/dashboard";

export const Route = createFileRoute("/admin/tiffin-seva/dashboard")({
  component: Page,
});
